export default __webpack_public_path__ + "static/media/slide-1.00b8fbe7.jpg";